import { render, staticRenderFns } from "./DetailCourse.vue?vue&type=template&id=66870ad6&scoped=true&"
import script from "./DetailCourse.vue?vue&type=script&lang=js&"
export * from "./DetailCourse.vue?vue&type=script&lang=js&"
import style0 from "./DetailCourse.vue?vue&type=style&index=0&id=66870ad6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66870ad6",
  null
  
)

export default component.exports